@if (isOnline !== undefined) {
  <div>
    @if (isOnline) {
      <div class="onlineStatus fade-in" title="Endpoint Status">
        <div class="onlineImage"></div>
        <div class="buttonLabel labelOnline">Online</div>
      </div>
    }
    @if (lastOnlineTime !== undefined && !isOnline) {
      <div class="onlineStatus fade-in" title="Endpoint Status">
        <div class="offlineImage"></div>
        <div class="buttonLabel labelOnline">
          Last Seen<br />
          <span style="font-weight: 400">{{ lastOnlineTime }}</span>
        </div>
      </div>
    }
    @if (lastOnlineTime === undefined) {
      <div class="onlineStatus fade-in" title="Endpoint Status">
        <div class="offlineImage"></div>
        <div class="buttonLabel labelOnline">
          Last Seen<br />
          <span style="font-weight: 400">Never</span>
        </div>
      </div>
    }
  </div>
}
